import script from "./CustomPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomPage.vue?vue&type=script&setup=true&lang=ts"

import "./CustomPage.vue?vue&type=style&index=0&id=4ab68f5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ab68f5b"]])

export default __exports__